import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";

export class ValidateDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: []
    };

    this.logger = Log;
  }

  updateVisibility = (key, value) => {
    this.props.updateVisibility(key, value);
  };

  runConfirm = key => {
    this.updateVisibility(key, false);
    this.props.runConfirm();
  };

  render() {
    return (
      <div>
        <pr.Dialog
          header={this.props.header + " Changes Made"}
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Yes"
                icon="pi pi-check"
                onClick={() => {
                  this.runConfirm(this.props.visibleField);
                }}
                style={{
                  float: "right"
                }}
              />
              <pr.Button
                className="secondary-btn"
                label="No"
                icon="pi pi-times"
                onClick={() => {
                  this.updateVisibility(this.props.visibleField, false);
                }}
                style={{
                  float: "right"
                }}
              />
            </div>
          }
          visible={this.props.isVisible}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.updateVisibility(this.props.visibleField, false)}
        >
          Are you sure you want to leave this page? All changes will be lost
        </pr.Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/ValidateDialog.js